import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import {
  Sparkles, Flame, Crown, Share2, Rocket, CalendarCheck, Heart, BookOpen, Lock, Award,
} from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ICONS = {
  Sparkles, Flame, Crown, Share2, Rocket, CalendarCheck, Heart, BookOpen, Award,
};

const BadgesShowcase = () => {
  const { getAuthHeader, user } = useAuth();
  const { t } = useLanguage();
  const [badges, setBadges] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/badges`, { headers: user ? getAuthHeader() : {} })
      .then((res) => setBadges(res.data.badges || []))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (badges.length === 0) return null;

  return (
    <div
      className="bg-white dark:bg-[#2D2A26] border-2 border-black dark:border-white rounded-xl p-6 hard-shadow-lg"
      data-testid="badges-showcase"
    >
      <h3 className="text-2xl font-bold mb-6 dark:text-white" style={{ fontFamily: 'Merriweather, serif' }}>
        {t('badges.title')}
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {badges.map((b) => {
          const Icon = ICONS[b.icon] || Award;
          const earned = b.earned;
          return (
            <div
              key={b.id}
              data-testid={`badge-card-${b.id}`}
              className={`relative flex flex-col items-center text-center p-4 rounded-xl border-2 transition-all ${
                earned
                  ? 'border-black dark:border-white hard-shadow-hover'
                  : 'border-dashed border-gray-300 dark:border-gray-600 opacity-70'
              }`}
              style={earned ? { backgroundColor: `${b.color}22` } : {}}
            >
              <div
                className="w-12 h-12 rounded-full border-2 flex items-center justify-center mb-2"
                style={{
                  backgroundColor: earned ? b.color : 'transparent',
                  borderColor: earned ? '#000' : '#9ca3af',
                }}
              >
                {earned ? (
                  <Icon className="w-6 h-6 text-black" strokeWidth={2.5} />
                ) : (
                  <Lock className="w-5 h-5 text-gray-400" strokeWidth={2.5} />
                )}
              </div>
              <span className="font-bold text-sm dark:text-white">{b.name}</span>
              <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">{b.description}</span>
              <span
                className={`mt-2 text-[10px] font-bold uppercase px-2 py-0.5 rounded-full ${
                  earned ? 'bg-[#34D399] text-black' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
                }`}
              >
                {earned ? t('badges.earned') : t('badges.locked')}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BadgesShowcase;
